import React from 'react'
import { Title, TitleContainer, ToggleIcon } from './Accordion.style'

interface Props {
    title: string
    content: React.ReactNode
}

const Accordion: React.FC<Props> = ({ title, content }) => {
    const [expanded, setExpanded] = React.useState(false)

    const toggleExpanded = () => {
        setExpanded(!expanded)
    }

    return (
        <>
            <TitleContainer $opened={expanded} onClick={toggleExpanded}>
                <Title>{title}</Title>
                <ToggleIcon className={`wemolo-chevron-${expanded ? 'down' : 'up'}`} />
            </TitleContainer>
            {expanded && <div>{content}</div>}
        </>
    )
}
export default Accordion
